import React from "react";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { BrandLogo } from "components/Flowstate";
import { palette } from "../palette";

const CONTACT = [
  { icon: EmailOutlinedIcon, label: "core@edgent.in", href: "mailto:core@edgent.in" },
  { icon: PhoneOutlinedIcon, label: "+91 8340156311", href: "tel:+918340156311" },
  { icon: WhatsAppIcon, label: "WhatsApp us", href: "https://wa.me/918340156311" },
  {
    icon: LinkedInIcon,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/edgent-ai/",
  },
];

const EXPLORE = [
  { label: "How it works", href: "#how-it-works" },
  { label: "What we cover", href: "#what-we-cover" },
  { label: "Why we take 50", href: "#the-fifty" },
];

const linkSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  color: palette.textMuted,
  fontSize: 14.5,
  mb: 1.5,
  textDecoration: "none",
  transition: "color 0.2s ease",
  "&:hover": { color: palette.primary },
};

export const SiteFooter = () => (
  <Box
    component="footer"
    sx={{
      backgroundColor: palette.bgAlt,
      borderTop: `1px solid ${palette.border}`,
      color: palette.text,
      pt: { xs: 7, md: 9 },
      pb: 5,
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 5, md: 4 }}>
        <Grid item xs={12} md={5}>
          <BrandLogo size="medium" isLight to="/flowstate" />
          <Typography
            component="p"
            sx={{
              color: palette.textMuted,
              fontSize: 15,
              lineHeight: 1.65,
              mt: 2.5,
              maxWidth: 360,
            }}
          >
            FlowState is a small group of AI engineers, data scientists and
            founders who teach AI one to one — from first principles through to
            production systems.
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography
            component="p"
            sx={{ fontWeight: 700, fontSize: 15, color: palette.text, mb: 2.5 }}
          >
            Explore
          </Typography>
          {EXPLORE.map((item) => (
            <Box key={item.label} component="a" href={item.href} sx={linkSx}>
              {item.label}
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography
            component="p"
            sx={{ fontWeight: 700, fontSize: 15, color: palette.text, mb: 2.5 }}
          >
            Talk to us
          </Typography>
          {CONTACT.map(({ icon: Icon, label, href }) => (
            <Link
              key={label}
              href={href}
              underline="none"
              target={href.startsWith("http") ? "_blank" : undefined}
              rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
              sx={linkSx}
            >
              <Icon sx={{ fontSize: 19 }} />
              {label}
            </Link>
          ))}
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: { xs: 5, md: 7 },
          pt: 3,
          borderTop: `1px solid ${palette.border}`,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <Typography component="p" sx={{ color: palette.textFaint, fontSize: 13.5 }}>
          © {new Date().getFullYear()} FlowState. All rights reserved.
        </Typography>
        <Box sx={{ display: "flex", gap: 3 }}>
          {[
            { label: "Terms", href: "/interview-prep/terms" },
            { label: "Privacy", href: "/interview-prep/privacy" },
            { label: "Refunds", href: "/interview-prep/refund" },
          ].map(({ label: t, href }) => (
            <Box
              key={t}
              component="a"
              href={href}
              sx={{
                color: palette.textFaint,
                fontSize: 13.5,
                textDecoration: "none",
                "&:hover": { color: palette.primary },
              }}
            >
              {t}
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  </Box>
);

export default SiteFooter;
